// $(document).on('click', '.angebotebutton', function(e){
//     console.log("a");
// 	var cid="";
// 	var lid="";
// 	var kataid="";
// 	var datumvon="";
// 	var datumbis="";
// 	var preisvon="";
// 	var preisbis="";

// 	var searchterm = "";

// 	if ($(".reiseart").val() > 0)
// 	{cid = $('.reiseart').val();}

// 	if ($(".reisekatalog").val() > 0)
// 	{
// 		kataid = $('.reisekatalog').val();
// 		searchterm += "&kataid="+kataid;
// 	}

// 	if ($(".reiseziel").val() != null) {
// 		if ($(".reiseziel").val().length  > 0 && $(".reiseziel").val()  != -1)
// 		{lid = $('.reiseziel').val();}
// 	}

// 	if($(".preisvon").val() != undefined)
// 	{
// 		if ($(".preisvon").val().length  > 0)
// 		{
// 			preisvon = $('.preisvon').val();
// 			searchterm += "&preisvon="+preisvon;
// 		}
// 	}
// 	else
// 	{
// 		preisvon = 0;
// 	}

// 	if ($(".preisbis").val() != undefined)
// 	{
// 		if ($(".preisbis").val().length > 0)
// 		{
// 			preisbis = $('.preisbis').val();
// 			searchterm += "&preisbis="+preisbis;
// 		}
// 	}
// 	else
// 	{
// 		preisbis = 0;
// 	}

// 	if ($(".anreise").val() != undefined)
// 	{
// 		if ($(".anreise").val().length  > 0)
// 		{
// 			datumvon = $('.anreise').val();
// 			datumvon = datumvon.split(".").reverse().join("-");
// 			searchterm += "&datumvon="+datumvon;
// 		}
// 	}

// 	if ($(".abreise").val() != undefined)
// 	{
// 		if ($(".abreise").val().length > 0)
// 		{
// 			datumbis = $('.abreise').val();
// 			datumbis = datumbis.split(".").reverse().join("-");
// 			searchterm += "&datumbis="+datumbis;
// 		}
// 	}

// 	if ($(".suchbox").val().length > 0)
// 	{
// 		searchterm += "&suchparameter="+$(".suchbox").val();
// 	}

// 	window.document.location.href = window.location.origin+"/index.php?type=reiseuebersicht&kid="+cid+"&lid="+lid+searchterm;

// });

// $(document).on('keyup','.suchbox', function(event) {
// 	var cid="";
// 	var lid="";
// 	if ($(".reiseart").val() > 0)
// 	{cid = $('.reiseart').val();}
// if ($(".reiseziel").val() != null) {
// 	if ($(".reiseziel").val().length  > 0)
// 	{lid = $('.reiseziel').val();}
// }
//     if (event.keyCode == 13) {
//         if ($(".suchbox").val().length > 0)
// 		{
// 			window.document.location.href = window.location.origin+"/index.php?type=reiseuebersicht&kid="+cid+"&lid="+lid+"&suchparameter="+$(".suchbox").val();
// 		}
// 		else
// 		{
// 			window.document.location.href = window.location.origin+"/index.php?type=reiseuebersicht&kid="+cid+"&lid="+lid;
// 		}
//     }
// });

// $(document).on('click', '.einzelkontakt .kontakt', function(e) {
//     e.preventDefault();
//     var Href = 'index.php?type=popup&cid=' + $(this).attr("linkform")+"&kontakt="+$(this).attr("linkan");

//     $.fancybox.open({
//         href: Href,
//         type: 'iframe',
//         padding: 5
//     });
// });


/*$(document).on('click', '.buchungsbutton', function(e) {
    e.preventDefault();
    var Href = 'index.php?type=popup&cid=14_Reiseplus_Buchungsformular&rid='+$(this).attr("rid");

    $.fancybox.open({
        href: Href,
        type: 'iframe',
        padding: 5
    });
});*/

$(document).on('click', '.buchungsbuttonauswahl', function(e) {
    e.preventDefault();
    $(".buchungsanfrage").show();
    $('html,body').animate({scrollTop: $(".buchungsanfrage").offset().top});
    // var Href = 'index.php?type=popup&cid=14_Reiseplus_Buchungsformular&rid='+$(this).attr("rid")+'&pid='+$(this).attr("pid");

    // $.fancybox.open({
        // href: Href,
        // type: 'iframe',
        // padding: 5
    // });
});

// $(document).on('click', '.anfragebuttonauswahl', function(e) {
//     e.preventDefault();
//     var Href = 'index.php?type=popup&cid=18_Reiseplus_Buchungsanfrage&rid='+$(this).attr("rid")+'&pid='+$(this).attr("pid");

//     $.fancybox.open({
//         href: Href,
//         type: 'iframe',
//         padding: 5
//     });
// });


var winLoc = window.location.search;
winLoc = winLoc.replace('?', '').split('&');
var locbez = winLoc[0].split('=').pop();
if(locbez = "reiseuebersicht"){
    $( document ).ready(function() {
        $('#pageination').easyPaginate({
            paginateElement: $('.ergebnisse'),
            elementsPerPage: 6,
            firstButton: true,
            firstButtonText: "",
            lastButton: true,
            lastButtonText: "",
            prevButton: true,
            prevButtonText: "",
            nextButton: true,
            nextButtonText: "",
        });
        $(".easyPaginateNav a").appendTo(".edt-pagination");
        $(".easyPaginateNav").remove();
        $(".edt-pagination").addClass("easyPaginateNav");
        $('[data-toggle="tooltip"]').tooltip();
    });
}
// if(locbez = "content"){
    // $( document ).ready(function() {
        // $('.reviewdiv').wrapAll( "<div id='review_all' />");
        // $('#review_all').easyPaginate({
            // paginateElement: $('.reviewdiv'),
            // elementsPerPage: 5,
            // firstButton: true,
            // lastButton: true,
            // prevButton: true,
            // nextButton: true,
        // });
    // });
// }
if(locbez = "reisedetail"){
    $( document ).ready(function() {
        $('.detailheaderinfo li:first').addClass('active');
        $('.tab-pane.fade:first').addClass('in active');
    });
}


$(document).on('change', '.reisesorting', function(e) {
    e.preventDefault();
	var newsearch = window.location.href;
	var hash = location.hash;
	newsearch = setGetParameter(newsearch, hash, "sort",$('option:selected', this).attr("sort"));
	newsearch = setGetParameter(newsearch, hash, "sortdir",$('option:selected', this).attr("sortdir"));
	newsearch = setGetParameter(newsearch, hash, "sortnr",$('option:selected', this).attr("value"));
	window.location.href = newsearch;
});

function setGetParameter(url, hash, paramName, paramValue)
{
    url = url.replace(hash, '');
    if (url.indexOf(paramName + "=") >= 0)
    {
        var prefix = url.substring(0, url.indexOf(paramName));
        var suffix = url.substring(url.indexOf(paramName));
        suffix = suffix.substring(suffix.indexOf("=") + 1);
        suffix = (suffix.indexOf("&") >= 0) ? suffix.substring(suffix.indexOf("&")) : "";
        url = prefix + paramName + "=" + paramValue + suffix;
    }
    else
    {
    if (url.indexOf("?") < 0)
        url += "?" + paramName + "=" + paramValue;
    else
        url += "&" + paramName + "=" + paramValue;
    }
    //window.location.href = url + hash;
	return url + hash;
}



$(document).on('click', '.addAttendee', function(e) {
var counter = $(this).attr('anzahl');
counter++;
var personen = $(this).attr('personen');
personen++;

var html = $('.alphateilnehmer').html();
html = html.replace(/Pers1/g,'Pers'+counter);
html += '<div class="deleteTeilnehmer rahmendiv col-xs-12 col-sm-12 col-md-12 col-lg-12" col="12"><div class="karedformbuttondiv col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="karedformbutton delAttendee" feld="Pers'+counter+'">Teilnehmer löschen</div></div></div>';

	$('.reiseteilnehmer').append(html);
	$(this).attr('anzahl',counter);
	$(this).attr('personen',personen);

	$('.personenauswahl').append('<option value="'+personen+'">'+personen+' Personen</option>');

	getTotal();
});

$(document).on('click', '.delAttendee', function(e) {
var feld = $(this).attr('feld');

$('div.'+feld).remove();


$("select[class='karedformselect personenauswahl']").each(function(i, obj) {

		$(obj).find(" option:last").remove();

	});

var personen = parseFloat($('.addAttendee').attr('personen'));
$('.addAttendee').attr('personen',personen-1);

getTotal();
$(this).remove();
});


$(document).on('change', '.personenauswahl', function(e) {
	var singlepreis = parseFloat($(this).attr('zusatzpreis'));
	var label = $(this).attr('preisfuer');

	var elem = parseFloat($(this).val());
	var erg = elem*singlepreis;


	erg = formatNumber(erg);
	$("."+label).val(erg+ " €");
	$("."+label+"H").val(erg.replace(".",",")+ " Euro");

	getTotal();
});

$(document).on('change', '.leistungsselect', function(e) {
	//console.log($('option:selected', this).attr("preis"));
	var elem = parseFloat($('option:selected', this).attr("preis"));
	elem = formatNumber(elem);
	$("."+$(this).attr("pricefor")+"Preis").val(elem+ " €");
	$("."+$(this).attr("pricefor")+"Preisanzeige").val(elem+ " Euro");

	getTotal();
});

function formatNumber(number)
{
    number = number.toFixed(2) + '';
	number = number.replace(".", ",");
    x = number.split(',');
    x1 = x[0];
    x2 = x.length > 1 ? ',' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + '.' + '$2');
    }
    return x1 + x2;
}

function getTotal()
{
	var total = 0;
	$('.leistungsselect').each(function(i, obj) {
		total += parseFloat($('option:selected', obj).attr("preis"));
	});
	$('.personenauswahl').each(function(i, obj) {
		var singlepreis = parseFloat($(obj).attr('zusatzpreis'));
		var anz = parseFloat($(obj).val());
		total += (singlepreis*anz);
	});

	$('.endpreisbuchung').val(formatNumber(total)+" €");
	$('.endpreisbuchungausgabe').val(formatNumber(total)+" Euro");
}


$(function(){
	// $('form').ebcaptcha();

	var url = window.location.pathname.replace(/\//g,"")+window.location.search;
	var linksToGoogle = $('a[href="'+url+'"]');

	linksToGoogle.each(function(i, obj) {
		$(obj).parents('li').addClass('active');
	});

	var linksside = $('.sideicon[link="'+url+'"]');
	linksside.each(function(i, obj) {
		var srcimage = $(obj).attr('src');
		srcimage = srcimage.replace(".png","");
		srcimage = srcimage+"_active.png";
		$(obj).attr('src',srcimage);
	});
});

$(document).on('click', '.copyAttendee', function(e) {
	$('input[name="Pers1 Vorname"]').val($('input[name="Kontaktperson Vorname"]').val());
	$('input[name="Pers1 Nachname"]').val($('input[name="Kontaktperson Name"]').val());
	$('select[name="Pers1 Anrede"]').val($('select[name="Kontaktperson Anrede"]').val());
});

function isValidDate2(s) {
	s = s+"";
  var bits = s.split('.');
  var y = bits[2], m  = bits[1], d = bits[0];
  // Assume not leap year by default (note zero index for Jan)
  var daysInMonth = [31,28,31,30,31,30,31,31,30,31,30,31];

  // If evenly divisible by 4 and not evenly divisible by 100,
  // or is evenly divisible by 400, then a leap year
  if ( (!(y % 4) && y % 100) || !(y % 400)) {
    daysInMonth[1] = 29;
  }
  return d <= daysInMonth[--m]
}

var optionsdate =  {
	onComplete: function(cep) {
		if (!isValidDate2(cep))
		{
			alert(unescape("Bitte geben Sie eine g%FCltiges Datum ein."));
		}
	},
	placeholder:  "__.__.____"
};

$(document).ready(function() {
	$('.anreise').valida();
	$('.abreise').valida();
    $(".edt-top-sf-t-item").html($("#edt-top-carousel").find(".active .sliderinformationen").html())
	// $('.anreise').mask('00.00.0000', optionsdate);
	// $('.abreise').mask('00.00.0000', optionsdate);

	// var _dateRangePickerOptions = {
        // separator : ' - ',
        // language:'de',
        // format: 'DD.MM.YYYY',
        // getValue: function()
        // {
            // if ($('.anreise').val() && $('.abreise').val() )
                // return $('.anreise').val() + ' - ' + $('.abreise').val();
            // else
                // return '';
        // },
        // setValue: function(s,s1,s2)
        // {
            // $('.anreise').val(s1);
            // $('.abreise').val(s2);
        // }
    // };

	// if ($('.anreise').length > 0){
    // $('.anreise').dateRangePicker(_dateRangePickerOptions);
	// }
	// if ($('.abreise').length > 0){
    // $('.abreise').dateRangePicker(_dateRangePickerOptions);
	// }
    $("#edt-top-carousel").bind('slid.bs.carousel', function (e) {
           $(".edt-top-sf-t-item").html($(this).find(".active .sliderinformationen").html())
    });

    $(".fancybox").fancybox();
});

$(document).on('click', '.showTerminePreise', function(e){

  $("li a[href='#terminepreise']").trigger("click");
});

$(document).on('click', ".edt-det-box .edt-det-carousel .smallpic_reise", function(e){
    $(".edt-det-box .bigpic_reise").css("background-image", 'url("'+$(this).find("img").attr("image_link")+'"), linear-gradient(to right, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), url("'+$(this).find("img").attr("image_link")+'")');
    $(".edt-det-box .bigpic_reise .reisedetail_copyright").text($(this).parent().find(".reisedetail_copyright").text());
});
